import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MenuModule } from 'primeng/menu';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ToastModule } from 'primeng/toast';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { MultiSelectModule } from 'primeng/multiselect';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { FileUploadModule } from 'primeng/fileupload';
import { TextareaModule } from 'primeng/textarea';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { ListboxModule } from 'primeng/listbox';

import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';

import { AlertService } from './services/alert.service';

import { SecurePipe } from './pipes/secure.pipe';
import { StringJoinPipe } from './pipes/string-join.pipe';
import { HtmlTextPipe } from './pipes/plaintext.pipe';
import { DurationPipe } from './pipes/duration.pipe';
import { PrettyJsonPipe } from './pipes/prettyJson.pipe';

import { TopBarComponent } from './components/top-bar/top-bar.component';

import { AutoFocusModule } from 'primeng/autofocus';
import { AccordionModule } from 'primeng/accordion';
import { ColorPickerModule } from 'primeng/colorpicker';
import { CardModule } from 'primeng/card';
import { ClickOutsideDirective } from './directives/clickOutside';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TabViewModule } from 'primeng/tabview';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ButtonModule } from 'primeng/button';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

const components = [
  TopBarComponent
];

const pipes = [SecurePipe, StringJoinPipe, HtmlTextPipe, DurationPipe, PrettyJsonPipe];

const services = [AlertService, ConfirmationService];

const primeNgModules = [
  MenuModule,
  AutoCompleteModule,
  ToastModule,
  DropdownModule,
  CalendarModule,
  MultiSelectModule,
  DialogModule,
  DropdownModule,
  TableModule,
  TagModule,
  FileUploadModule,
  AutoFocusModule,
  AccordionModule,
  TextareaModule,
  InputTextModule,
  CheckboxModule,
  ListboxModule,
  ColorPickerModule,
  CardModule,
  RadioButtonModule,
  TabViewModule,
  SelectButtonModule,
  ConfirmDialogModule,
  ButtonModule,
  CKEditorModule
];

const directives = [ClickOutsideDirective];

@NgModule({
  imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule, ...primeNgModules],
  declarations: [
    ...components,
    ...pipes,
    ...directives,
  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ...primeNgModules,
    ...components,
    ...pipes,
    ...directives,
  ],
})
export class SharedModule {
  static forRoot() {
    return {
      ngModule: SharedModule,
      providers: [...services],
    };
  }
}
